import { render } from "./Workspace.vue?vue&type=template&id=e35356ba"
import script from "./Workspace.vue?vue&type=script&lang=js"
export * from "./Workspace.vue?vue&type=script&lang=js"

import "./Workspace.vue?vue&type=style&index=0&id=e35356ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/Workspace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e35356ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e35356ba', __exports__)) {
    api.reload('e35356ba', __exports__)
  }
  
  module.hot.accept("./Workspace.vue?vue&type=template&id=e35356ba", () => {
    api.rerender('e35356ba', render)
  })

}


export default __exports__